import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { NetworkLinkButton } from './NetworkLinkButton';
import { getListByAlphabetOrder, Link as LinkType } from '../networkLinks/networkLinks.utils';
import { networkLinkButtonConfigThemeKey, NetworkLinkButtonThemeProps, networkLinkButtonListConfigThemeKey } from './NetworkLinkButton.theme';
import { useTheme } from '../../../theming/useTheme';
import { useThemeOverride } from '../../../theming/useThemeOverride';
import { ThemeContext } from '../../../theming/ThemeProviderWithFonts';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

const getStyles = () => {
  return StyleSheet.create({
    list: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: '5px',
      listStyle: 'none',
      margin: 0,
      padding: '20px 0',
    },
  });
};

interface NetworkLinkButtonListProps {
  links: LinkType[];
}

export const NetworkLinkButtonList: React.FunctionComponent<NetworkLinkButtonListProps> = props => {
  const networkLinkButtonListTheme = useTheme<NetworkLinkButtonThemeProps>(networkLinkButtonListConfigThemeKey);
  const networkLinkButtonOverride = useThemeOverride<NetworkLinkButtonThemeProps>(networkLinkButtonListTheme, networkLinkButtonConfigThemeKey);
  const { links = [] } = props;
  const styles = getStyles();

  if (!links.length) {
    return null;
  }

  const sortedLinks = getListByAlphabetOrder(links);
  return (
    <ErrorBoundary>
      <ul className={css(styles.list)}>
        {sortedLinks.map((link, index) => (
          <li key={index}>
            <ThemeContext.Provider value={networkLinkButtonOverride}>
              <NetworkLinkButton {...link} />
            </ThemeContext.Provider>
          </li>
        ))}
      </ul>
    </ErrorBoundary>
  );
};
